/**
 * Imports for the Autodesk.Viewing.Scene namespace
 */

/**
 * When exporting a THREE type here, make sure adequate JSDoc comments for the public
 * documentation exist both in three-slim.js and related three-backports.js.
 * @note v7 uses three.js for APS, three-slim.js for fluent. v8 is planned to use three-slim.js exclusively.
 */

export { Node3D } from "../wgs/scene/scene-graph/Node3D";
export { InstanceNode3D } from "../wgs/scene/scene-graph/InstanceNode3D";

export { InstanceCollection3D } from "../wgs/scene/InstanceCollection3D";

export { VisibilityState } from "../wgs/scene/InstanceCollectionBase";

export { BufferGeometry } from "../wgs/scene/BufferGeometry";
export { BufferAttribute, Texture, Color } from "three";

export { GeometryFactory } from "../wgs/scene/GeometryFactory";

export { UnlitMaterial } from "../wgs/render/UnlitMaterial";
export { StandardMaterial } from "../wgs/render/StandardMaterial";
export { LineMaterial } from "../wgs/render/LineMaterial";
export { PointsMaterial } from "../wgs/render/PointsMaterial";

export { Side, Filter, Wrapping, Mapping, TextureFormat, TextureType } from "../wgs/scene/Constants";